import { ButtonGroup } from '@mui/material';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import AddEnhancedButton from 'components/ui/buttons/AddEnhancedButton';
import LinkEnhancedButton from 'components/ui/buttons/LinkEnhancedButton';
import { TenantPage } from 'layouts';
import { uniqueId } from 'lodash';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { equipmentInvoiceService } from 'shared/services';
import EquipmentInvoiceCreateDialog from '../components/dialog/EquipmentInvoiceCreateDialog';
import { EquipmentInvoicesColumns } from '../equipment-invoices';

export function EquipmentInvoices() {
  const { t } = useTranslation();
  const translationPrefix = 'pages.equipment-invoices.list';
  const datagridRefresh = useRef(null);

  const [openDialog, setOpenDialog] = useState(false);

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const onSubmit = (values) => {
    equipmentInvoiceService.add(values).then(() => {
      setOpenDialog(false);
      datagridRefresh.current();
    });
  };

  const columns = EquipmentInvoicesColumns(datagridRefresh.current);
  const filters = [];
  const initialParams = {};
  filters.push({
    id: uniqueId(),
    field: 'closed',
    operator: 'is',
    value: 'false'
  });
  initialParams['closed'] = 'false';

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={
        <ButtonGroup>
          <AddEnhancedButton prefix={translationPrefix} onClick={() => setOpenDialog(true)} />
          <LinkEnhancedButton label={t(`${translationPrefix}.all`)} to="all" />
        </ButtonGroup>
      }>
      <EnhancedDataGrid
        columns={columns}
        initialFilterItems={filters}
        initialParams={initialParams}
        service={equipmentInvoiceService}
        refresh={datagridRefresh}
      />
      <EquipmentInvoiceCreateDialog
        isOpen={openDialog}
        onClose={handleCloseDialog}
        onSubmit={onSubmit}
      />
    </TenantPage>
  );
}

export default EquipmentInvoices;
